module.exports = __webpack_public_path__ + "media/images/iconSettings__okGreen-aafabf2260b5cff95f524c1fab334cbe.png";